// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import MuiDialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";
import { useMediaQuery, useTheme } from "@mui/material";

/**
 * @param {{
 * open: Boolean,
 * onClose: Function,
 * title: string,
 * actions: JSX.Element,
 * sx: import("@mui/material").SxProps<import("@mui/material").Theme>,
 * PaperProps: Partial<PaperProps<"div", {}>>,
 * loading: Boolean,
 * defaultTitle: Boolean
 * }}
 */
export function Dialog({
  children,
  open,
  onClose,
  title,
  actions,
  sx,
  PaperProps,
  loading,
  defaultTitle,
  maxWidth,
  disableBackdropClick,
}) {
  const themes = useTheme();
  const content =
    typeof children === "string" ? <DialogContentText>{children}</DialogContentText> : children;

  const mobileMediaQuery = themes.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  return (
    <MuiDialog
      open={open}
      onClose={(event, reason) => {
        if (disableBackdropClick && reason === "backdropClick") return;
        if (!loading) onClose(event, reason);
      }}
      sx={sx}
      PaperProps={PaperProps}
      disableEscapeKeyDown
      maxWidth={maxWidth}
    >
      <DialogTitle>
        {defaultTitle ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              pt: isMobileDevice ? 0 : 3,
              fontSize: isMobileDevice ? 15 : 22,
            }}
          >
            {title}
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 10,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        ) : (
          title
        )}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
      {loading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            position: "absolute",
          }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </MuiDialog>
  );
}

Dialog.propTypes = {
  children: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.any,
  actions: PropTypes.any,
  sx: PropTypes.any,
  PaperProps: PropTypes.any,
  loading: PropTypes.bool,
  defaultTitle: PropTypes.bool,
  maxWidth: PropTypes.string,
  disableBackdropClick: PropTypes.bool,
  fullScreen: PropTypes.bool,
  onClick: PropTypes.func,
};
